import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Divider, IconButton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';

const PoojaCounts = () => {
    const [counts, setCounts] = useState({
        pending: 0,
        accepted: 0,
        ongoing: 0,
        completed: 0,
        rejected: 0,
        unverified: 0,
        verified: 0,
        mediaRejected: 0
    });
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);

    const fetchCounts = async (isRefresh = false) => {
        if (isRefresh) setRefreshing(true);
        else setLoading(true);

        try {
            const token = localStorage.getItem("astroVani-admin-token");
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/pooja/counts`, {
                headers: {
                    Authorization: token
                }
            });
            const result = await response.json();
            if (result.success) {
                setCounts(result.data);
            } else {
                toast.error(result.message || "Failed to fetch pooja counts");
            }
        } catch (error) {
            console.error("Failed to fetch pooja counts", error);
            toast.error(error.message || "An error occurred while fetching counts");
        } finally {
            if (isRefresh) setRefreshing(false);
            else setLoading(false);
        }
    };

    useEffect(() => {
        fetchCounts();
    }, []);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" my={1}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    const cards = [
        { label: 'Pending', value: counts.pending || 0, color: '#ff9800' },
        { label: 'Accepted', value: counts.accepted || 0, color: '#2196f3' },
        { label: 'Ongoing', value: counts.ongoing || 0, color: '#00bcd4' },
        { label: 'Completed', value: counts.completed || 0, color: '#4caf50' },
        { label: 'Rejected', value: counts.rejected || 0, color: '#f44336' },
        { label: 'Unverified', value: counts.unverified || 0, color: '#607d8b' },
        { label: 'Verified', value: counts.verified || 0, color: '#009688' },
        { label: 'Rejected', value: counts.mediaRejected || 0, color: '#e91e63' },
    ];

    return (
        <Box mb={2} display="flex" flexWrap="wrap" gap={2} sx={{
            backgroundColor: '#fff',
            p: 1.5,
            px: 2,
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            border: '1px solid #f0f0f0',
            alignItems: 'center'
        }}>
            {cards.map((card, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                    {card.label === "Pending" &&
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#555' }}>
                            Pooja Status:
                        </Typography>
                    }
                    {card.label === "Unverified" && <>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#555'}}>
                            Creative Verification:
                        </Typography>

                    </>
                    }
                    <Box key={index} display="flex" alignItems="center" gap={1} style={{ border: "1px solid #ccc", padding: "5px 10px", borderRadius: 5 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: card.color }} />
                        <Typography variant="body2" color="textSecondary" sx={{ fontWeight: 500 }}>
                            {card.label}:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                            {card.value}
                        </Typography>
                        {index < cards.length - 1 && (
                            <Divider orientation="vertical" flexItem sx={{ ml: 1, my: 0.5, borderColor: '#e0e0e0' }} />
                        )}
                    </Box>
                    {card.label === "Unverified" && <br/> }
                </Box>
            ))}

            <Box sx={{ flexGrow: 1 }} />
            <Tooltip title="Refresh Counts">
                <IconButton onClick={() => fetchCounts(true)} size="small" disabled={refreshing} sx={{ border: '1px solid #ccc', borderRadius: '8px' }}>
                    {refreshing ? <CircularProgress size={16} /> : <i className="icofont-refresh text-primary" style={{ fontSize: '16px' }}></i>}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default PoojaCounts;
